import React, { useContext } from 'react';
import { OrderContext } from '../contexts/OrderContext'
import './Items.css'
export default function Items() {
  const order = useContext(OrderContext).order

  return (
    <section id="Historico-table">
      {order.items.map(item => (
        <table className='table-items'>
          <thead>
            <tr>
              <th>Produto</th>
              <th>SKU</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th id='quantity'>Quantidade</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><img alt="Imagem de pedido
                  " src={item?.imageUrl} /></td>
              <td>{item?.sellerSku}</td>
              <td>{item?.name}</td>
              <td>{item.price / 100}</td>
              <td>{item?.quantity}</td>
            </tr>
          </tbody>
        </table>
      ))}
    </section>
  )
}